import styled from 'styled-components';

export const CompanyContainerStyled = styled.div`
  .title_layout {
    margin-bottom: 19px;
  }

`;
